document.addEventListener("DOMContentLoaded", function () {

    const header = document.querySelector(".header-wrapper");

    if (!header) return;

    function toggleHeader() {

        if (window.scrollY > 40) {

            header.classList.add("abid-scrolled");

        } else {

            header.classList.remove("abid-scrolled");

        }

    }

    toggleHeader();

    window.addEventListener("scroll", toggleHeader);

});

document.addEventListener("DOMContentLoaded", () => {

    /* ==========================
       Sticky Header
    ========================== */

    const header = document.querySelector(".header-wrapper");

    const toggleHeader = () => {

        if (!header) return;

        if (window.scrollY > 40) {

            header.classList.add("abid-scrolled");

        } else {

            header.classList.remove("abid-scrolled");

        }

    };

    toggleHeader();

    window.addEventListener("scroll", toggleHeader);

    /* ==========================
       AJAX Cart
    ========================== */

    document.querySelectorAll(".abid-cart-form").forEach(form => {

        form.addEventListener("submit", async e => {

            e.preventDefault();

            const button = form.querySelector(".abid-add-cart");

            const text = button.querySelector("span");

            button.disabled = true;

            text.textContent = "ADDING...";

            const formData = new FormData(form);

            try{

                const response = await fetch("/cart/add.js",{

                    method:"POST",

                    body:formData

                });

                if(!response.ok){

                    throw new Error();

                }

                text.textContent = "ADDED ✓";

                /* Refresh cart sections */

                document.dispatchEvent(new CustomEvent("cart:refresh"));

                setTimeout(()=>{

                    text.textContent="ADD TO BAG";

                    button.disabled=false;

                },1200);

            }catch(e){

                text.textContent="TRY AGAIN";

                button.disabled=false;

            }

        });

    });

});


/* ==========================================================
   TESTIMONIAL SLIDER
========================================================== */

document.querySelectorAll('.abid-testimonial-wrapper').forEach(wrapper=>{

    const slider=wrapper.querySelector('.abid-testimonial-slider');

    wrapper.querySelector('.abid-testimonial-next').onclick=()=>{

        slider.scrollBy({

            left:slider.clientWidth/3,

            behavior:'smooth'

        });

    };

    wrapper.querySelector('.abid-testimonial-prev').onclick=()=>{

        slider.scrollBy({

            left:-slider.clientWidth/3,

            behavior:'smooth'

        });

    };

});

/* ==========================================================
ABID REVEAL ENGINE
========================================================== */

window.addEventListener("load",()=>{

    const observer=new IntersectionObserver(

        (entries)=>{

        entries.forEach(entry=>{

        if(entry.isIntersecting){

        entry.target.classList.add("is-visible");

        observer.unobserve(entry.target);

        }

        });

        },

        {

        root:null,

        threshold:.08,

        rootMargin:"150px"

        }

        );

    document.querySelectorAll(

        ".reveal,.reveal-left,.reveal-right,.reveal-scale,.reveal-stagger"

    ).forEach(el=>{

        observer.observe(el);

    });

});

/* ==========================================================
PARALLAX
========================================================== */

const parallaxItems=document.querySelectorAll(".parallax");

window.addEventListener("scroll",()=>{

    const scroll=window.pageYOffset;

    parallaxItems.forEach(item=>{

        const speed=.08;

        item.style.transform=`translateY(${scroll*speed}px)`;

    });

});